module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[7]372.08870d4.woff2";